<template>
    <div class="d-flex align-items-center justify-content-center">
        <template v-if="row.Gender == 'Erkek'">
            <span class="material-icons-round mr-50 text-primary">male</span>
            {{row.Gender}}
        </template>
        <template v-else-if="row.Gender == 'Kadın'">
            <span class="material-icons-round mr-50 text-danger">female</span>
            {{row.Gender}}
        </template>
        <template v-else><span>-</span></template>
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>

</style>